import React, { useEffect, useState } from "react";
import {
  Button,
  Drawer,
  Spin,
  Avatar,
  Card,
  Col,
  Row,
  Typography,
  notification,
  Badge,
  Tabs,
  Skeleton,
  Input,
  message,
  Tag,
  Space,
  Popconfirm,
  Alert,
  Modal,
Tooltip
} from "antd";

import {
  EditOutlined,
  EllipsisOutlined,
  SettingOutlined,
  ClockCircleOutlined,
  LinkOutlined,
  IdcardOutlined,
  MessageOutlined,
  InfoCircleOutlined,
  EditTwoTone,
  ArrowRightOutlined,
  GiftOutlined,
  CheckCircleFilled,
  PercentageOutlined,
} from "@ant-design/icons";

import ReportChat from "../ReportChat";
import MultipleShipment from "../MultipleShipment";
import logo from "../../assets/images/logo.png";

import {
  getPlans,
  checkOutSession,
  getSubscriptions,
  PD_ICON,
  checkCouponCode,
  trailCheckOutSession,

  AppSupportedInfo
} from "./../../services";

const { Meta } = Card;

const { Title, Paragraph, Text, Link } = Typography;
const PdProducts = ({
  isactive,
  isClose,
  subsInfo,
  type,
  infoData,
  giftCheckOut,
  shipments
}) => {
  const [visible, setVisible] = useState(isactive);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [giftPlans, setGiftPlans] = useState([]);
  const [state, setState] = useState(null);
  const [couponID, setCouponId] = useState(false);

  const [prIndex, setIndex] = useState(0);
  const [discountInfo, setDiscountInfo] = useState({});
  const [validCoupon, setValidCoupon] = useState(false);
  const [validPromo, setValidPromo] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleIframeLoad = () => {
    setLoading(false);
  };

  const couponEnter = (e) => {
    const { value } = e.target;

    console.log(value);
    setCouponId(value);
  };

  const resetCoupon = () => {
    setValidCoupon(false);
    setValidPromo(false);
    setCouponId(false);
  };

  const autoCouponApply = () => {
    const { coupon } = infoData;

    if (coupon && coupon != "") {
      const coupon_code = localStorage.getItem("coupon_code");

      console.log(coupon_code);
      setCouponId(coupon_code);

      setValidCoupon(true);
      couponApply();
    }
  };

  const couponApply = async (priceData, couponType, indexItem) => {
    console.log(priceData);

    console.log(couponID);

    if (couponID) {
      const cpResponse = await checkCouponCode(couponID, couponType, priceData);

      console.log(cpResponse);

      if (cpResponse && cpResponse.status === "success") {
        message.success(cpResponse.message);

        if (couponType === "coupon") {
          setValidCoupon(true);
          setDiscountInfo({});
        }

        if (couponType === "promo") {
          setValidPromo(true);
          setDiscountInfo(cpResponse.data);
        }

        setIndex(indexItem);
      } else {
        message.warn(cpResponse.message);
      }
    }

    // console.log(cpResponse);
  };

  const fetchData = async () => {

    // console.log(shipments);
    setLoading(true);
    // getPlans
    // Simulate API call
    // setTimeout(() => {
    //   // Replace this with your actual API call
    //   const mockData = [{ id: 1, name: 'Item 1' }, { id: 2, name: 'Item 2' }];
    //   setData(mockData);
    //   setLoading(false);
    // }, 2000); // Simulating 2 seconds delay

    // if(type==="order"){
    //   setLoading(true);
    //   message.info("Loading Shipment Details...");  
    //   setLoading(false);
    // }
    
    if(type==="subscription"){
      const pd_plans = await getPlans();

      if (pd_plans.status === "success") {
        let subscriptionData = pd_plans.data;
        const { coupon } = infoData;

        // if (coupon && coupon != "") {
        //     subscriptionData.shift();
        // }

        console.log(subscriptionData);
        setData(subscriptionData);

        setGiftPlans(pd_plans.gift_plans);
      }
  }

    // console.log(pd_plans);
    setLoading(false);
  };

  useEffect(() => {
    console.log(infoData);
    fetchData();
    autoCouponApply();
  }, [infoData]);

  const subscriptionInit = async (prod) => {
    console.log(prod);

    // const { unit_amount } = prod;

    // if (unit_amount === 0) {
    //   const subResponse = await checkOutSession(prod);

    //   if (subResponse.status === "success") {
    //     const { url } = subResponse.data;

    //     localStorage.removeItem("coupon_valid");
    //     localStorage.removeItem("coupon_code");

    //     window.location.href = url;
    //   } else {
    //     notification.error({
    //       message: "Coupon Code is Invalid",
    //     });
    //   }
    //   setLoading(false);
    //   return;
    // }

    const is_exist_sub = await getSubscriptions();
    const { status, is_payment, is_sensor, is_subscription, is_status } =
      is_exist_sub.data;

     if(is_subscription  && prod.unit_amount ===0){
        notification.info({
          message: "Free Trial Not Available",
          description: "You already have an subscription, so the free trial cannot be used.",
        });
        return;
     }

    // console.log(is_exist_sub.data);

    // if (is_status !== "canceled" ) {
    //   notification.info({
    //     message: "Info",
    //     description: "Subscription  Already Purchased.",
    //   });
    //   return;
    // }
    // if (is_payment === false && prod.type === "recurring") {
    //     notification.info({
    //       message: "Info",
    //       description: "Please purchase a sensor first, then create a subscription.",
    //     });

    //     return;
    // }

    // if (prod.type === "one_time" && is_payment === true) {
    //   notification.info({
    //     message: "Info",
    //     description: "Sensor MemberShip Already Purchased, Try Subscription.",
    //   });

    //   return;
    // }

    // if (prod.type === "recurring" && is_subscription === true) {

    //   notification.info({
    //     message: "Info",
    //     description: "Subscription  Already Purchased.",
    //   });

    //   return;
    // }

    setLoading(true);

    prod.customer_id = subsInfo.customerId;
    prod.sensor_details = {};

    prod.discount_info = discountInfo?.coupon;

    if (validCoupon && couponID) {
      prod.coupon = couponID;
    }

    if (validPromo && couponID) {
      console.log(discountInfo);

      prod.promo = discountInfo.id;
    }


  // prod.paymentMethodId = 'pm_1S5oc2AApC6judFc7ADJ3M2B';

    const subResponse = await checkOutSession(prod);

    if (subResponse.status === "success") {
      const { url } = subResponse.data;

      localStorage.removeItem("coupon_valid");
      localStorage.removeItem("coupon_code");

      window.location.href = url;
    } else {
      notification.error({
        message: "Coupon Code is Invalid",
      });
    }
    setLoading(false);
  };


  const trailSubscriptionInit = async (prod) => {
    console.log(prod);

    const { unit_amount } = prod;

    if (unit_amount === 0) {
      const subResponse = await trailCheckOutSession(prod);

      if (subResponse.status === "success") {
        const { url } = subResponse.data;

        localStorage.removeItem("coupon_valid");
        localStorage.removeItem("coupon_code");

        window.location.href = url;
      } else {
        notification.error({
          message: "Coupon Code is Invalid",
        });
      }
      setLoading(false);
      return;
    }

    const is_exist_sub = await getSubscriptions();
    const { status, is_payment, is_sensor, is_subscription, is_status } =
      is_exist_sub.data;

    // console.log(is_exist_sub.data);

    // if (is_status !== "canceled" ) {
    //   notification.info({
    //     message: "Info",
    //     description: "Subscription  Already Purchased.",
    //   });
    //   return;
    // }
    // if (is_payment === false && prod.type === "recurring") {
    //     notification.info({
    //       message: "Info",
    //       description: "Please purchase a sensor first, then create a subscription.",
    //     });

    //     return;
    // }

    // if (prod.type === "one_time" && is_payment === true) {
    //   notification.info({
    //     message: "Info",
    //     description: "Sensor MemberShip Already Purchased, Try Subscription.",
    //   });

    //   return;
    // }

    // if (prod.type === "recurring" && is_subscription === true) {

    //   notification.info({
    //     message: "Info",
    //     description: "Subscription  Already Purchased.",
    //   });

    //   return;
    // }

    setLoading(true);

    prod.customer_id = subsInfo.customerId;
    prod.sensor_details = {};

    prod.discount_info = discountInfo?.coupon;

    if (validCoupon && couponID) {
      prod.coupon = couponID;
    }

    if (validPromo && couponID) {
      console.log(discountInfo);

      prod.promo = discountInfo.id;
    }

    const subResponse = await checkOutSession(prod);

    if (subResponse.status === "success") {
      const { url } = subResponse.data;

      localStorage.removeItem("coupon_valid");
      localStorage.removeItem("coupon_code");

      window.location.href = url;
    } else {
      notification.error({
        message: "Coupon Code is Invalid",
      });
    }
    setLoading(false);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleShowDrawer = () => {
    setVisible(true);
    fetchData();
  };

  const handleCloseDrawer = () => {
    setVisible(false);
  };

  const objEmpty = async (test) => {
    return test && typeof test === "object" && Object.keys(test).length > 0;
  };


  

  const giftInit = (giftProd) => {

   
    giftProd.customer_id = subsInfo.customerId;
    giftProd.sensor_details = {};

    giftProd.discount_info = discountInfo?.coupon;

    if (validPromo && couponID) {
      console.log(discountInfo);

      giftProd.promo = discountInfo.id;
    }


    giftProd.PLAN_TYPE="GIFT";

     subscriptionInit(giftProd);

    // console.log(discountInfo);
    // console.log(validCoupon);
    // console.log(validPromo);
    // console.log(validPromo);
    // console.log(giftProd);

    // giftCheckOut(giftProd);
  };

  const { shipstation_response, return_shipment_tracking } = infoData;

  console.log(shipstation_response);

  const shipstation_tracking =
    type === "order" && shipstation_response && objEmpty(shipstation_response)
      ? shipstation_response.trackingNumber
      : false;

  return (
    <>
      <Drawer
        title={
          type === "subscription"
            ? "Subscription Plans"
            : type === "gift_sub"
            ? "Gift Subscription Plans"
            : "Subscription Details"
        }
        placement="right"
        onClose={isClose}
        visible={isactive}
        className={"dashboard_drawer pdproducts_drawer"}
        footer={
          type === "subscription" ? (
            <>
              <Title level={5}>
                <br /> <br />
               
                 
                 <AppSupportedInfo isClosable={false}/>
                
                <Title type="warning" underline level={5}>
                  <LinkOutlined />{" "}
                  <a
                    target={"_blank"}
                    href="https://www.aletheia.run/term-of-sale"
                  >
                    Terms of Sale
                  </a>
                </Title>{" "}
              </Title>
            </>
          ) : (
            <></>
          )
        }
      >
        <Modal
          width={580}
          title={
            <Title style={{ color: "#ff9800" }} level={3}>
              Try Aletheia Run Free For 30 Days
            </Title>
          }
          open={isModalOpen}
          footer={null}
          onCancel={handleCancel}
        >
          <Paragraph>
            {" "}
            <Text style={{ fontSize: "15px" }} strong>
              The Aletheia Sensor, Charger, Belt, plus access to the Aletheia
              Run app included in a Free Trial may be either a new or pre-owned
              Aletheia Sensor, Charger, and Belt at the sole discretion of
              Aletheia Run. Any pre-owned Aletheia Sensor, Charger, and Belt
              provided as part of a Free Trial will have been thoroughly
              inspected and tested to ensure it is ready for use, but may have
              slight cosmetic damage such as minor scratches.{" "}
            </Text>{" "}
          </Paragraph>

          <Paragraph>
            {" "}
            <Text style={{ fontSize: "15px" }} strong>
              If a member cancels their Aletheia Run Trial but fails to return
              the Aletheia Sensor, Charger, and Belt within the Return Period,
              they may be charged a non-return equipment fee equal to the retail
              value of the Aletheia Sensor, Charger, and Belt. Aletheia Run
              reserves the right to take further action, including suspending
              future eligibility for Free Trials or memberships, and pursuing
              collection efforts as necessary.
            </Text>
          </Paragraph>
        </Modal>

        {type === "subscription" ? (
          <Spin spinning={loading}>
            {data ? (
              <Row>
                {/* <Title level={5}>
                              <br /> <br />
                              <p className="og_text">
                                {" "}
                                The Dasein App is currently only available for{" "}
                                <b>Apple iPhone </b>.<br /> An <b>Android </b>
                                version is coming soon!
                              </p>
                              <Title type="warning" underline level={5}>
                                <LinkOutlined />{" "}
                                <a
                                  target={"_blank"}
                                  href="https://www.projectdasein.com/term-of-sale"
                                >
                                  Terms of Sale
                                </a>
                              </Title>{" "}
                            </Title> */}

                {data.map((price, index) => (
                  
                  <Col xxl={24} xs={24}>
                    <Badge.Ribbon
                      color="#fa9e24"
                      text={
                        <>
                          {" "}
                          <ClockCircleOutlined /> {price?.metadata?.membership}
                        </>
                      }
                    >
                      <Card
                        className={`gift_card_block ${price?.unit_amount > 0 ? 'free': 'annual'}_product `}
                        
                        cover={
                          <>
                            <div
                              style={{
                                padding: " 40px",
                                width: "100%",
                                textAlign: "center",
                                
                              }}
                              
                            >
                              <Row>
                                <Col span={12}>
                                  <div className="text-left">
                                    <Title>
                                      $
                                      {price?.metadata?.learnmore
                                        ? 0
                                        : price.unit_amount / 100}
                                      <Title
                                        style={{ display: "contents" }}
                                        level={5}
                                      >
                                        / {price?.metadata?.recurring}
                                      </Title>
                                    </Title>
                                  </div>
                                </Col>
                                <Col span={12}>
                                  <div>
                                    <img
                                      style={{
                                        height: 50,

                                        margin: "0 auto",
                                      }}
                                      alt="example"
                                      src="https://pd-filemanager.s3.us-west-2.amazonaws.com/pdIcon.png"
                                    />{" "}
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </>
                        }
                        actions={[
                          // <>
                          //   {price?.metadata?.recurring === "Year" ? (
                          //     <span
                          //       className={
                          //         validCoupon ? "action_btn_ok" : "action_btn"
                          //       }

                          //       // onClick={() => giftInit(price)}
                          //     >
                          //       <Popconfirm
                          //         icon={false}
                          //         title={
                          //           <>
                          //             <Alert
                          //               message="Gift Coupon Apply Here"
                          //               type="warning"
                          //               showIcon
                          //             />
                          //             {validCoupon ? (
                          //               <Tag
                          //                 style={{ fontSize: "18px" }}
                          //                 color="green"
                          //               >
                          //                 Coupon Code: <b>{couponID}</b> is
                          //                 Applied &nbsp;&nbsp;
                          //                 <EditTwoTone
                          //                   onClick={resetCoupon}
                          //                   style={{ fontSize: "25px" }}
                          //                 />{" "}
                          //               </Tag>
                          //             ) : (
                          //               <>
                          //                 <Input.Group compact>
                          //                   <Input
                          //                     style={{
                          //                       width: "250px",
                          //                     }}
                          //                     onKeyUp={couponEnter}
                          //                     placeholder="Coupon Code"
                          //                     defaultValue={
                          //                       validCoupon && couponID
                          //                         ? couponID
                          //                         : ""
                          //                     }
                          //                   />
                          //                   <Button
                          //                     onClick={() =>
                          //                       couponApply(
                          //                         price,
                          //                         "coupon",
                          //                         index
                          //                       )
                          //                     }
                          //                     type="primary"
                          //                   >
                          //                     Apply
                          //                   </Button>
                          //                 </Input.Group>
                          //                 <br />
                          //               </>
                          //             )}
                          //           </>
                          //         }
                          //         showCancel={false}
                          //         okText={""}
                          //       >
                          //         {validCoupon ? (
                          //           <CheckCircleFilled key="setting" />
                          //         ) : (
                          //           <GiftOutlined key="setting" />
                          //         )}{" "}
                          //        <span className="UA"> GIFT COUPON {validCoupon ? "APPLIED" : " "}</span>
                          //         &nbsp;
                          //       </Popconfirm>
                          //     </span>
                          //   ) : (
                          //     ""
                          //   )}
                          // </>,
                          <>
                            {price?.metadata ? (
                              <span
                                className={
                                  validPromo ? "action_btn_ok" : "action_btn"
                                }

                                // onClick={() => giftInit(price)}
                              >
                                <Popconfirm
                                  icon={false}
                                  title={
                                    <>
                                      <Alert
                                        message="Promo Code Apply Here"
                                        type="warning"
                                        showIcon
                                      />
                                      {validPromo ? (
                                        <Tag
                                          style={{ fontSize: "18px" }}
                                          color="green"
                                        >
                                          PROMO Code: <b>{couponID}</b> is
                                          Applied &nbsp;&nbsp;
                                          <EditTwoTone
                                            onClick={resetCoupon}
                                            style={{ fontSize: "25px" }}
                                          />{" "}
                                        </Tag>
                                      ) : (
                                        <>
                                          <Input.Group compact>
                                            <Input
                                              style={{
                                                width: "250px",
                                              }}
                                              onKeyUp={couponEnter}
                                              placeholder="Promo Code"
                                              defaultValue={
                                                validPromo && couponID
                                                  ? couponID
                                                  : ""
                                              }
                                            />
                                            <Button
                                              onClick={() =>
                                                couponApply(
                                                  price,
                                                  "promo",
                                                  index
                                                )
                                              }
                                              type="primary"
                                            >
                                              Apply
                                            </Button>
                                          </Input.Group>
                                          <br />
                                        </>
                                      )}
                                    </>
                                  }
                                  showCancel={false}
                                  okText={""}
                                >
                                  {validPromo ? (
                                    <CheckCircleFilled key="setting" />
                                  ) : (
                                    <PercentageOutlined key="setting" />
                                  )}{" "}
                                <span className="UA">  PROMO CODE {validPromo ? "APPLIED" : " "}</span>
                                  &nbsp;
                                </Popconfirm>
                              </span>
                            ) : (
                              ""
                            )}
                          </>,

                          <>
                            <span
                              className="action_btn"
                              // onClick={() => price?.unit_amount===0 ? trailSubscriptionInit(price) : subscriptionInit(price)}
                              
                              onClick={() => price?.unit_amount===0 ? subscriptionInit(price) : subscriptionInit(price)}
                            >
                              PURCHASE <span className="UA">PLAN</span> <ArrowRightOutlined /> &nbsp;
                            </span>
                          </>,
                        ]}
                      >
                        <Meta
                          avatar={<Avatar src={logo} />}
                          title={price?.metadata?.title}
                          description={
                            <>
                              {price?.metadata?.description}{" "}
                              {price?.metadata?.learnmore ? (
                                <a
                                  onClick={showModal}
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                  }}
                                  href="#"
                                >
                                  Learn More
                                </a>
                              ) : (
                                ""
                              )}{" "}
                            </>
                          }
                        />
                      </Card>
                      <br />
                    </Badge.Ribbon>
                    <br />
                  </Col>
                ))}
              </Row>
            ) : (
              <p>No data available</p>
            )}
          </Spin>
        ) : type === "gift_sub" ? (
          <>
            <div>
              {giftPlans.map((gift, index) => (
                //  <Badge.Ribbon  color="#fa9e24" text={<> <ClockCircleOutlined />  {gift?.metadata?.recurring === "Year" ? " Recurring Yearly " : "Recurring Monthly" }</>}>
                <Badge.Ribbon
                  color="#fa9e24"
                  text={
                    <>
                      {" "}
                      <ClockCircleOutlined /> {gift?.metadata?.membership}
                    </>
                  }
                >
                  <Card
                    className="gift_card_block"
                    cover={
                      <>
                        <div
                          style={{
                            padding: " 40px",
                            width: "100%",
                            textAlign: "center",
                          }}
                        >
                          <Row>
                            <Col span={12}>
                              <div className="text-left">
                                <Title>
                                  ${gift.unit_amount / 100}
                                  <Title
                                    style={{ display: "contents" }}
                                    level={5}
                                  >
                                    / {gift?.metadata?.recurring}
                                  </Title>
                                </Title>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div>
                                <img
                                  style={{
                                    height: 50,

                                    margin: "0 auto",
                                  }}
                                  alt="example"
                                  src="https://pd-filemanager.s3.us-west-2.amazonaws.com/pdIcon.png"
                                />{" "}
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </>
                    }
                    actions={[
                      <>
                        <span
                          className={
                            index === prIndex && validPromo
                              ? "action_btn_ok"
                              : "action_btn"
                          }

                          // onClick={() => giftInit(price)}
                        >
                          <Popconfirm
                            icon={false}
                            title={
                              <>
                                <Alert
                                  message="Promo Code Apply Here"
                                  type="warning"
                                  showIcon
                                />
                                {validPromo ? (
                                  <Tag
                                    style={{ fontSize: "18px" }}
                                    color="green"
                                  >
                                    PROMO Code: <b>{couponID}</b> is Applied
                                    &nbsp;&nbsp;
                                    <EditTwoTone
                                      onClick={resetCoupon}
                                      style={{ fontSize: "25px" }}
                                    />{" "}
                                  </Tag>
                                ) : (
                                  <>
                                    <Input.Group compact>
                                      <Input
                                        style={{
                                          width: "250px",
                                        }}
                                        onKeyUp={couponEnter}
                                        placeholder="Promo Code"
                                        defaultValue={
                                          validPromo && couponID ? couponID : ""
                                        }
                                      />
                                      <Button
                                        onClick={() =>
                                          couponApply(gift, "promo", index)
                                        }
                                        type="primary"
                                      >
                                        Apply
                                      </Button>
                                    </Input.Group>
                                    <br />
                                  </>
                                )}
                              </>
                            }
                            showCancel={false}
                            okText={""}
                          >
                            {validPromo ? (
                              <CheckCircleFilled key="setting" />
                            ) : (
                              <PercentageOutlined key="setting" />
                            )}{" "}
                            PROMO CODE {prIndex && validPromo ? "APPLIED" : " "}
                            &nbsp;
                          </Popconfirm>
                        </span>
                      </>,
                      <span
                        className="action_btn"
                        onClick={() => giftInit(gift)}
                      >
                        {" "}
                        BUY AS GIFT <ArrowRightOutlined /> &nbsp;
                      </span>,
                    ]}
                  >
                    <Meta
                      avatar={
                        <Avatar
                          style={{ backgroundColor: "#fa9e24" }}
                          icon={<GiftOutlined />}
                        />
                      }
                      title={gift?.metadata?.title}
                      description={
                        <>
                          Members receive a free Aletheia sensor included with a
                          one year subscription.{" "}
                          <span>
                            <p></p> Please note a temporary{" "}
                            <b style={{ color: "#fa9e24" }}>"giftuser"</b> email
                            will be assigned on the checkout page which will be
                            replaced with the gift recipient's email address
                            when they register their account.{" "}
                          </span>{" "}
                        </>
                      }
                    />
                  </Card>
                  <br />
                </Badge.Ribbon>
              ))}
            </div>
          </>
        ) : (
          <div>
            <Tabs defaultActiveKey="1">
              {shipstation_tracking ? (
                <Tabs.TabPane
                  tab={
                    <>
                      <IdcardOutlined />
                      Shipment Tracking
                    </>
                  }
                  key="1"
                >
                  {loading && <Spin />}
                  <iframe
                    title="example"
                    width={"100%"}
                    noborder
                    src={shipstation_response.tracker.public_url}
                    style={{
                      display: loading ? "none" : "block",
                      border: "none",
                      height: "900px",
                    }}
                    onLoad={handleIframeLoad}
                  />
                </Tabs.TabPane>
              ) : (
                ""
              )}

              {return_shipment_tracking ? (
                <Tabs.TabPane
                  tab={
                    <>
                      <IdcardOutlined />
                      Return Shippment Tracking
                    </>
                  }
                  key="4"
                >
                  {}
                 
                  <iframe
                    title="example"
                    width={"100%"}
                    noborder
                    src={shipstation_response.tracker.public_url}
                    style={{
                      display: loading ? "none" : "block",
                      border: "none",
                      height: "900px",
                    }}
                    onLoad={handleIframeLoad}
                  />
                </Tabs.TabPane>
              ) : (
                ""
              )}

             
              {shipments && shipments.length > 0 ? (  <Tabs.TabPane
                tab={
                  <>
                    <InfoCircleOutlined /> Shipments
                  </>
                }
                key="5"
              >

                <MultipleShipment isSelecetd={infoData}  data={shipments}  />
                
              </Tabs.TabPane>) : ''}



              <Tabs.TabPane
                tab={
                  <>
                    <InfoCircleOutlined /> Help
                  </>
                }
                key="3"
              >

             
                <iframe
                  title="example"
                  width={"100%"}
                  noborder
                  src="https://docs.aletheia.run"
                  style={{
                    display: loading ? "none" : "block",
                    border: "none",
                    height: "900px",
                  }}
                  onLoad={handleIframeLoad}
                />
              </Tabs.TabPane>
              {/* <Tabs.TabPane
                tab={
                  <>
                    <MessageOutlined /> Support
                  </>
                }
                key="2"
              >
                <ReportChat {...infoData} />
              </Tabs.TabPane> */}
            </Tabs>
          </div>
        )}
      </Drawer>
    </>
  );
};

export default PdProducts;
